export const syncAdapterRTTI = Symbol.for("SyncAdapter");
export const twilsockAdapterRTTI = Symbol.for("TwilsockAdapter");
export const httpAdapterRTTI = Symbol.for("HttpAdapter");
export const telemetryServiceRTTI = "TelemetryService";
export const queueStatsServiceRTTI = "QueueStatsService";
export const configurationServiceRTTI = "ConfigurationService";
